import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import { TextField, InputAdornment } from '@mui/material';
import { StandaloneSearchBox } from '@react-google-maps/api';

import LocalizationIcon from '@images/svg-icons/localizationIcon.svg';

import GoogleMapsScriptProvider from '@components/styled-UI/GoogleMapsScriptProvider';
import { IQuickSearch } from '@interfaces/myProfileInterfaces';

import { getLabelFallback } from '@utils/utils';

import { SubmitHandler, useForm } from 'react-hook-form';

type SearchBox = google.maps.places.SearchBox;

const MyStoresQuickSearch = (): JSX.Element => {
    const { register, handleSubmit } = useForm();

    const config = useSelector((state: RootState) => state.common.config);
    const [searchBox, setSearchBox] = useState<SearchBox>(null);

    const onGeolocate = () => {
        console.log('geolocate pls');
        navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
            const coords = position.coords;
            console.log(coords);
            // TODO: inverse geocoding
            // 1. make request to https://maps.googleapis.com/maps/api/geocode/json?latlng={lat},{leng}&key=YOUR_API_KEY
            // 2. use the answer to fill the input field
        });
    };

    const onSearchBoxLoad = (searchBox: SearchBox) => setSearchBox(searchBox);

    const onPlacesChanged = () => console.log(searchBox.getPlaces());

    const onSubmit: SubmitHandler<IQuickSearch> = (data: IQuickSearch) => {
        window.open(
            config.callFromComponentToTO.myProfile.myStores.findAStore
                .replace(
                    '{LOCATION_ENTRY}',
                    data.searchParameter ? data.searchParameter : 'new+york' // TODO: ??????
                )
                .replace('{CATALOG_ID}', config.catalogId)
                .replace('{LANG_ID}', config.langId)
                .replace('{STORE_ID}', config.storeId),
            '_parent'
        );
    };

    return (
        <div className="my-stores_quick-search content-container">
            <span className="primary-message medium align-left bold mb-4">
                {getLabelFallback('MY_STORES_QUICK_SEARCH_TITLE')}
            </span>
            <div className="primary-message medium align-left">
                {getLabelFallback('MY_STORES_QUICK_SEARCH_INFORMATION_MESSAGE')}
            </div>
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                <div className="search-bar-container form-group">
                    <GoogleMapsScriptProvider googleMapsApiKey={config?.googleMapsKey}>
                        <StandaloneSearchBox
                            onLoad={onSearchBoxLoad}
                            onPlacesChanged={onPlacesChanged}
                        >
                            <TextField
                                {...register('searchParameter')}
                                className="input-search"
                                name="searchParameter"
                                variant="outlined"
                                placeholder={getLabelFallback(
                                    'MY_STORES_QUICK_SEARCH_COMPONENT_PLACEHOLDER'
                                )}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment className="extra-large" position="end">
                                            <button
                                                className="geolocation"
                                                title="Use current location"
                                                aria-label="Use current location"
                                            >
                                                <LocalizationIcon />
                                            </button>
                                            <button
                                                type="submit"
                                                onClick={onGeolocate}
                                                className="primary-button black button-size-extra-small"
                                            >
                                                {getLabelFallback(
                                                    'MY_STORES_QUICK_SEARCH_COMPONENT_CTA'
                                                )}
                                            </button>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </StandaloneSearchBox>
                    </GoogleMapsScriptProvider>
                </div>
            </form>
        </div>
    );
};
export default MyStoresQuickSearch;
